module.exports = __webpack_public_path__ + "img/investorLogo.9b992aec.jpg";